
namespace _Ext {

    @Serenity.Decorators.registerClass() 
    export class AuditLogViewerDialog extends Serenity.TemplatedDialog<any> {

        constructor(public request: AuditLogViewerRequest) {
            super();

            this.dialogTitle = 'Audit Log Viewer'

            this.onDialogOpen = () => {

                AuditLogViewerService.List(this.request, response => {
                    response.EntityVersions.forEach(e => {
                        //delete (e.Id)


                        e.OldEntity = e.OldEntity != null ? JSON.parse(e.OldEntity) as any : null;
                        e.NewEntity = JSON.parse(e.NewEntity)

                        if (e.OldEntity != null) {
                            delete ((e.OldEntity as any).Id);
                            delete ((e.OldEntity as any).IDate);
                            delete ((e.OldEntity as any).IUser);
                            delete ((e.OldEntity as any).EDate);
                            delete ((e.OldEntity as any).EUser);
                        }
                        e.ActionType = AuditActionType[e.ActionType] as any;
                        (e as any).isShowed = false;
                    });

                    new Vue(new AuditLogViewer('#' + this.idPrefix + 'dialogContent', response.EntityVersions));


                })

            };
        }

        protected getTemplateName(): string {
            usingVuejs();
            usingJsonDiffPatch();
            return '_Ext.AuditLogViewer'
        }

    }

}
